import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext({ verplaatsingen: {}, meta: {}, verplaats: async () => {}, herstel: async () => {} });

/** Menu-indeling (8 bouwstenen) die voor alle medewerkers geldt; alleen directie wijzigt. */
export function MenuIndelingProvider({ children }) {
  const { user } = useAuth();
  const [state, setState] = useState({ verplaatsingen: {}, bijgewerkt_op: null, door: null });
  const laad = useCallback(() => api.get("/menu/indeling").then((r) => setState(r.data || {})).catch(() => {}), []);
  useEffect(() => { if (user?.id) laad(); }, [user?.id, laad]);
  const verplaats = useCallback(async (pad, domein) => {
    const { data } = await api.patch("/menu/indeling", { pad, domein });
    setState(data);
    return data;
  }, []);
  const herstel = useCallback(async () => {
    const { data } = await api.delete("/menu/indeling");
    setState(data);
    return data;
  }, []);
  return <Ctx.Provider value={{ verplaatsingen: state.verplaatsingen || {}, meta: { bijgewerkt_op: state.bijgewerkt_op, door: state.door }, verplaats, herstel, herlaad: laad }}>{children}</Ctx.Provider>;
}

export const useMenuIndeling = () => useContext(Ctx);
